

import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
//import PanchangLinks from '../../../components/PanchangLinks/PanchangLinks';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './SubhoHora.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import axios from 'axios';
import { Link } from 'react-router-dom';
import city from '../../../city.json'

const SubhoHora = () => {



  const planetTooltips = {
  Sun: "Energetic & authoritative. Best for political, govt, or leadership tasks.",
  Moon: "Gentle & nurturing. Ideal for food, caregiving, or creative tasks.",
  Mars: "Aggressive & sharp. Suitable for sports, engineering, and bravery tasks.",
  Mercury: "Fast & intelligent. Great for communication, writing, and travel.",
  Jupiter: "Auspicious & wise. Best for spiritual, financial, or educational tasks.",
  Venus: "Pleasure & beauty. Favorable for love, marriage, and artistic pursuits.",
  Saturn: "Slow & steady. Good for long-term plans, real estate, and agriculture.",
};


  const parseTime = (timeStr, baseDate = new Date()) => {
  const [hours, minutes] = timeStr.split(":").map(Number);
  const date = new Date(baseDate);
  date.setHours(hours, minutes, 0, 0);
  return date;
};




  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
  const [dayMuhurta, setDayMuhurta] = useState([]);
 // const [nightMuhurta, setNightMuhurta] = useState([]);
  const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"

  const [currentHora, setCurrentHora] = useState(null);



     // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);
const [selectedHora, setSelectedHora] = useState(null);



useEffect(() => {
  const fetchHoraData = async () => {
    try {
      const date = currentDate.toISOString().split("T")[0];

if (!location || location.trim() === '') return;

      const response = await axios.get(`https://core-c343.onrender.com/api/hora?date=${date}&location=${encodeURIComponent(location)}`);

     // const data = response.data;

      console.log('Fetching data for date:', formattedDate, 'at', location);

      const { horas } = response.data;

      const formattedHoras = horas.map(h => ({
        title: `${h.planet}`,
        time: `${h.start} to ${h.end}`
      }));

      setDayMuhurta(formattedHoras); // reuse this state for all horas


      const now = new Date();

const activeHora = formattedHoras.find(({ time }) => {
  const [startStr, endStr] = time.split(" to ");
  const start = parseTime(startStr, currentDate);
  const end = parseTime(endStr, currentDate);

  // Handle overnight range (if needed)
  if (end < start) {
    return now >= start || now <= end;
  }

  return now >= start && now <= end;
});

setCurrentHora(activeHora || null);

      

    } catch (error) {
      console.error("API error", error);
      setDayMuhurta([]);
    }
  };
      const debounce = setTimeout(fetchHoraData, 500);
    return () => clearTimeout(debounce);

 
}, [currentDate, location]);



  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  const convertTime = (timeStr) => {
    const [start, end] = timeStr.split(" to ");
    const format = (t) => {
      let [h, m] = t.split(":");
      h = parseInt(h);
      m = m || "00";
      if (timeFormat === "12") {
        const ampm = h >= 12 ? "PM" : "AM";
        h = h % 12 || 12;
        return `${String(h).padStart(2, "0")}:${m} ${ampm}`;
      } else if (timeFormat === "24") {
        return `${String(h).padStart(2, "0")}:${m}`;
      } else {
        return `${t}`;
      }
    };
    return `${format(start)} to ${format(end)}`;
  };

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

  return (
    <div className="SubhoHora-container">
      <InnerNav />
      <div className="SubhoHora-content">
        <Zodiac />
        <div className="SubhoHora-details">
                <div className="title">Subha Hora Muhurat Table</div>
                {/* <div className="sub">Running Do Ghati Muhurat</div> */}
              <div className="header">
                <div className="img-details">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
                  <div className="right">
                    {currentHora && (
                        <div className="now-running">
                          <h3>Now Running:</h3>
                          <div className="muhurta-card highlight">
                            <div className="title">{currentHora.title}</div>
                            <div className="time">{convertTime(currentHora.time)}</div>
                          </div>
                        </div>
                      )}

                  </div>
                </div>
                <div className="date-display">
                  <span className="day">{currentDate.getDate()}</span>
                  <span className="month">{readableDate}</span>
                </div>
              </div>

              <div className="controls">
                <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div>

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

               <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

<div className="muhurta-section">
  {!selectedHora ? (
    /* ========= LIST VIEW ========= */
    <>
      <div className="muhurta-header">
        <div className="muhurta-date">{readableDate}, {weekDay}</div>
      </div>

      <div className="muhurta-columns">
        <div className="muhurta-column day">
          <span>🕰️ Subha Hora List</span>

          {dayMuhurta.map((item, idx) => (
            <div
              key={idx}
              className="muhurta-card clickable"
              onClick={() => setSelectedHora(item)}
            >
              <div className="title">{item.title} Hora</div>
              <div className="time">{convertTime(item.time)}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  ) : (
    /* ========= DETAIL VIEW ========= */
    <div className="hora-detail-page">
      <button
      type="button"
        className="back-btn"
        onClick={() => setSelectedHora(null)}
      >
        ← Back
      </button>

      <h2>{selectedHora.title} Hora</h2>

      <p>
        <strong>Time:</strong> {convertTime(selectedHora.time)}
      </p>

      <p className="description">
        {planetTooltips[selectedHora.title]}
      </p>
    </div>
  )}
</div>

            </div>

      <section className="hora-wrapper">
      <h1 className="hora-title">About Hora Chakra</h1>
      <div className="hora-texts">
        <p>
          Usually people consult Panditji to find a good Muhurta and Panditji after consulting Panchang gives a nice Muhurta. Many times, due to various reasons, it is not possible to consult a Pandit. Hence Jyotish Shastra has created Hora Chakra to find auspicious and inauspicious timings for a day. Hora cycle makes it easy for an individual to choose a good Muhurta without consulting a Pandit.
        </p>

        <p>
          Hora is written as होरा in Sanskrit. होरा is derived from (अ)होरा(त्र). The time duration of one day and one night is known as अहोरात्र. In Vedic time keeping, it is the duration from one sunrise to next sunrise. Hence Hora word has been derived after removing first and last alphabet of (A)Hora(t). It is interesting to know that in Spanish Hora means time.
        </p>

        <p>
          There are 7 different Hora and total 24 Hora in a day. All seven Hora are cyclic and rotate in a constant fixed cycle throughout day and night.
        </p>

        <p>
          In Tamil Nadu people follow Nalla Neram and 
          <Link to="/muhurat/gowri-panchangam" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
            Gouri Nalla Neram 
          </Link>
          for each day. Nalla Neram is auspicious time according to Shubha Horai table and Gowri Nalla Neram is Shubha timings in a day mentioned in Tamil
          <Link to="/muhurat/gowri-panchangam" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
            Gouri Panchangam.
          </Link> 
          
        </p>

        <h2>Significance of Seven Hora</h2>

        <h3>Sun Hora</h3>
        <p>
          It is also known as Surya Hora. It is first Hora on Raviwar or Sunday. Surya Hora is energetic, vigorous, dynamic and powerful. Hence it is good for political work, court related dealings, meeting politicians and government officials, submitting tender, handing over or taking responsibility and joining government job. Sun Hora is positively more effective on Tuesday, Thursday and Sunday and it is detrimental on Friday and Saturday.
        </p>
        <p>
          Hora of Sun is good to wear or to adorn Manik (माणिक) jewel. Manik is adorned to appease and to get blessing of Lord Surya.
        </p>

        <h3>Venus Hora</h3>
        <p>
          It is also known as Shukra Hora. It is first Hora on Shukrawar or Friday. Shukra hora is beneficial, aesthetic and uniting. Hence it is recommended for love, romance, marriage and mating activities. Recreational activities like music, art and dance are also recommended during Hora of Venus. Venus Hora is positively more effective on Wednesday, Friday and Saturday and it is less effective on Sunday.
        </p>
        <p>
          Hora of Venus is good to adorn Opal (ओपल) Jewel and any other diamond. Opal is adorned to appease Lord Shukra.
        </p>

        <h3>Mercury Hora</h3>
        <p>
          It is also known as Budha Hora. It is first Hora on Budhawar or Wednesday. Mercury Hora is quick, changeable and unstable. Hence it is recommended for education, learning new skills, changing place, finalizing written agreement and travel related activities. It is auspicious Hora for media and publishing industry. Mercury Hora is positively more effective on Wednesday, Friday and Saturday and it is less effective on Tuesday.
        </p>
        <p>
          Hora of Budha is good to adorn Panna (पन्ना) jewel. Panna is adorned to appease planet Budha.
        </p>

        <h3>Moon Hora</h3>
        <p>
          It is also known as Chandra Hora. It is first Hora on Somwar or Monday. Moon Hora is soft, gentle, delicate and fluctuating. Hence it is considered good for most activities. Hora of Moon is specially recommended for gardening, food related activities, sea related work, activities which are related to pearl and conch-shell, silver related work and feminine work. Moon Hora is positively more effective on Monday and Thursday and it is less effective on Saturday and Sunday.
        </p>
        <p>
          Hora of Moon is good to adorn Moti (मोती).
        </p>

        <h3>Saturn Hora</h3>
        <p>
          It is also known as Shani Hora. It is first Hora on Shaniwar or Saturday. Saturn Hora is sluggish, inactive and delaying. Hence it is best avoided for those activities which need speedy expedition. Hora of Shani is recommended for those activities which are related to oil, lead, glass and iron. It is also recommended for laying foundation, opening fixed deposit account, entering into new house and agriculture work. Saturn Hora is positively more effective on Wednesday, Friday and Saturday and it is detrimental on Monday, Tuesday and Sunday.
        </p>
        <p>
          Hora of Shani is good to adorn Neelam (नीलम) and Gomed (गोमेद) jewel. Neelam is adorned to appease Lord Shani and Gomed is recommended to appease Rahu.
        </p>

        <h3>Jupiter Hora</h3>
        <p>
          It is also known as Guru Hora. It is first Hora on Guruwar or Thursday. Guru Hora is favorable, fruitful and augmentative. Hence it is recommended for most auspicious activities. Hora of Guru is suitable for travelling and transportation, money exchange and other financial activities, starting house construction and entering into the house and spiritual activities. Jupiter Hora is positively more effective on Tuesday, Thursday and Sunday.
        </p>
        <p>
          Hora of Guru is also good for adorning Pukharaj (पुखराज) jewel. Pukharaj is adorned to appease Lord Brahaspati.
        </p>

        <h3>Mars Hora</h3>
        <p>
          It is also known as Mangal Hora. It is first Hora on Mangalwar or Tuesday. Mars Hora is sharp, aggressive and volatile in nature. Hence it should be avoided for auspicious work and important activities. Bravery works, sports and competitive activities, electrical and mechanical engineering works, fire related work, pursuing litigation, construction work can be performed during Hora of Mangal. Mars Hora is positively more effective on Tuesday, Thursday and Sunday and it is detrimental on Wednesday and Saturday.
        </p>
        <p>
          Hora of Mangal is also good for adorning Moonga (मूँगा) and Lahasuniya (लहसुनियाँ) jewel. Moonga is adorned to appease Lord Mangal and Lahasuniya is to appease Ketu.
        </p>
      </div>
    </section>

            
        <MuhuratLink/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default SubhoHora;
